import { ApiError, UnauthorizedError } from '@/errors'
import { Credentials } from '@/models'

import axios, { withToken } from './axios'

/**
 * Gets an authentication Token.
 *
 * @param credentials User email and password.
 */
export async function fetchToken (credentials: Credentials): Promise<string> {
  const params = new URLSearchParams()
  params.append('client_id', process.env.VUE_APP_CLIENT_ID as string)
  params.append('grant_type', 'password')
  params.append('userName', credentials.user)
  params.append('password', credentials.password)

  try {
    const response = await axios.post(
      '/token',
      params
    )

    return response.data.access_token
  } catch (error) {
    if (error.response) {
      const { data, status } = error.response
      return Promise.reject(new ApiError(
        data.error_description,
        data.error,
        status
      ))
    }

    return Promise.reject(error)
  }
}

/**
 * Gets a backoffice Token.
 *
 * @param token Valid authentication Token.
 */
export async function fetchTokenV2 (token: string): Promise<string> {
  try {
    const response = await axios.post(
      '/token-v2',
      null,
      withToken(token)
    )

    return response.data.token
  } catch (error) {
    if (error.response) {
      const { status } = error.response
      if (status === 401) {
        return Promise.reject(new UnauthorizedError())
      }
    }

    return Promise.reject(error)
  }
}
